module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=1.44"},{"quantity":0.03,"color":"#91E3AD","label":"1.44 - 2.38"},{"quantity":0.06,"color":"#DEFFB0","label":"2.38 - 3.54"},{"quantity":0.01,"color":"#FFE68C","label":"3.54 - 5.16"},{"quantity":9,"color":"#FF9982","label":"5.16 - 6.94"},{"quantity":12,"color":"#FF4D30","label":"6.94 - 9.99"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_90_wheat.json
// module id = YtGX
// module chunks = 171